import { call, put } from 'redux-saga/effects';
import {
  addExcelActivityNoteFailure,
  addExcelActivityNoteSuccess,
} from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { AddExcelActivityNoteRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import { addExcelActivityNote } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* addExcelActivityNoteSaga(
  action: AddExcelActivityNoteRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId, note } = action.payload;

    const response: ApiResponse = yield call(
      addExcelActivityNote,
      organisationId,
      note
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
    yield put(addExcelActivityNoteSuccess());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(addExcelActivityNoteFailure());
  }
}

